import {Injectable} from '@angular/core';
import {jwtDecode} from "jwt-decode";
import { json } from 'stream/consumers';

@Injectable({
  providedIn: 'root'
})
export class UserService {


  getJWTToken() : any {
    const token: string | null = localStorage.getItem('jwt');

    if (token !== null) {
      return JSON.parse(token)['token']
    }

    return null;
  }

  getUserFirstName() : any {
    const token: string | null = localStorage.getItem('jwt');
    if (token !== null) {
      let  username =  JSON.parse(token)['user_firstname'];
      if(!username){
        username =  jwtDecode(token)['username'];
      }
      return username;
    }
    return null;
  }

  getUserLastName() : any {
    const token: string | null = localStorage.getItem('jwt');

    if (token !== null) {
      return JSON.parse(token)['user_lastname']
    }

    return null;
  }

  getRoles() : any {
    const token: string | null = localStorage.getItem('jwt');

    if (token !== null) {
      const decodedJWT = jwtDecode(token)
      return decodedJWT['roles']
    }

    return [];
  }

  canEdit() : boolean {
    let roles = this.getRoles()
    return !(!roles.includes('CEM') && !roles.includes('SUPER_CEM'));
  }

  isSuperCem() : boolean {
    return this.getRoles().includes('SUPER_CEM');
  }
}
